import api from './api';
import { handleApiError } from '../utils/apiErrors';

export const authService = {
    login: async (credentials) => {
        try {
            const response = await api.post('/users/login', credentials);
            return response.data; // Axios returns data in response.data
        } catch (error) {
            return handleApiError(error);
        }
    },

    register: async (userData) => {
        try {
            const response = await api.post('/users', userData);
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    },

    checkUser: async (phoneNumber) => {
        try {
            const response = await api.post('/users/check', { phone: phoneNumber });
            return response.data;
        } catch (error) {
            return handleApiError(error);
        }
    }
};
